<script>
  import moment from 'moment';

  moment.updateLocale('en', {
    relativeTime: {
      future: '%s',
      past: '%s',
      s: 'right now',
      ss: '%d seconds ago',
      m: 'a minute ago',
      mm: '%d minutes ago',
      h: 'an hour ago',
      hh: '%dh ago',
      d: 'a day ago',
      dd: '%d days ago',
      M: 'a month ago',
      MM: '%d months ago',
      y: 'a year ago',
      yy: '%d years ago',
    },
  });

  export default {
    name: 'NotificationDrawerItem',

    props: {
      item: {
        type: Object,
        required: true,
      },
      dense: {
        type: Boolean,
        default: false,
      },
      timeFormat: {
        type: String,
        default: '',
      },
    },
    methods: {
      formatTime(timestamp) {
        if (this.timeFormat) {
          return moment(timestamp).format(this.timeFormat);
        }

        return moment(timestamp).fromNow();
      },
      acceptChallenge(challengeKey, alertKey, item) {
        this.$emit('accept', challengeKey, item, alertKey);
      },
      denyChallenge(challengeKey, alertKey, item) {
        this.$emit('deny', challengeKey, item, alertKey);
      },
      clearMessage(key) {
        this.$emit('clear', key);
      },
      acceptFriend(key) {
        this.$emit('acceptFriend', key.userId, key.key);
      },
      rejectFriend(key) {
        this.$emit('rejectFriend', key.userId, key.key);
      },
    },
  };
</script>

<template>
  <div v-if="item.type === 'REWARD'" class="reward-container py-3">
    <div class="font-weight-semi">
      {{ item.message }}
    </div>
    <v-icon v-if="!dense" color="white" size="18" @click="clearMessage(item.key)">mdi-close</v-icon>
  </div>
  <div v-else-if="item.type === 'REQUEST'" class="request-container">
    <div :class="item.online ? 'online' : 'offline'" class="dot" />
    <v-img v-if="!dense" v-reload-on-fail class="my-2 ml-2" src="/images/icons/avatar-glow.png" width="50" />
    <div class="px-4">
      <p class="font-weight-semi mb-0 mt-2">{{ item.message }}</p>
      <span class="font-weight-semi pl-1">
        {{ formatTime(item.timestamp) }}
      </span>
    </div>
    <v-icon v-if="!dense" color="white" size="18" class="justify-end" @click="clearMessage(item.key)">mdi-close</v-icon>
  </div>
  <div v-else-if="item.type === 'FRIEND_REQUEST'" class="request-container">
    <div v-if="item.type === 'FRIEND_REQUEST'" :class="item.online ? 'online' : 'offline'" class="dot" />
    <v-img v-if="!dense" v-reload-on-fail class="my-2 ml-2" src="/images/icons/avatar-glow.png" width="50" />
    <div class="pl-4 pr-0">
      <p class="font-weight-semi mb-0 mt-2">{{ item.message }}</p>
      <span class="font-weight-semi pl-1">
        {{ formatTime(item.timestamp) }}
      </span>
    </div>
    <div v-if="!item.deleted" class="d-flex request-container-buttons">
      <div class="button-container d-flex align-center justify-center cursor-pointer mr-2" style="background: #93cc41">
        <v-icon class="mr-0" color="white" size="16" @click="acceptFriend(item)">mdi-check</v-icon>
      </div>
      <div class="button-container d-flex align-center justify-center cursor-pointer" style="background: red">
        <v-icon class="mr-0" color="white" size="16" @click="rejectFriend(item)">mdi-close</v-icon>
      </div>
    </div>
  </div>
  <div v-else class="request-container">
    <div :class="item.online ? 'online' : 'offline'" class="dot" />
    <v-img v-if="!dense" v-reload-on-fail class="my-2 ml-2" src="/images/icons/avatar-glow.png" width="50" />
    <div class="pl-4 pr-0">
      <p class="font-weight-semi mb-0 mt-2">{{ item.message }}</p>
      <span class="font-weight-semi pl-1">
        {{ formatTime(item.timestamp) }}
      </span>
    </div>
    <div v-if="!item.deleted" class="d-flex request-container-buttons">
      <div class="button-container d-flex align-center justify-center cursor-pointer mr-2" style="background: #93cc41">
        <v-icon class="mr-0" color="white" size="16" @click="acceptChallenge(item.challengeKey, item.key, item)">
          mdi-check
        </v-icon>
      </div>
      <div class="button-container d-flex align-center justify-center cursor-pointer" style="background: red">
        <v-icon class="mr-0" color="white" size="16" @click="denyChallenge(item.challengeKey, item.key, item)">
          mdi-close
        </v-icon>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .reward-container {
    display: grid;
    grid-template-columns: auto 25px;
  }

  .request-container {
    display: grid;
    grid-template-columns: 20px 60px 1fr 60px;
    align-items: center;

    @media screen and (max-width: 1023px) {
      grid-template-columns: 20px 60px 1fr 100px;
    }

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: red;

      &.online {
        background-color: #93cc41;
      }

      &.unknown {
        background-color: #fff;
      }
    }

    .v-image {
      box-shadow: 0 0 6px gold;
    }

    p {
      line-height: 16px;
    }

    span {
      position: relative;
      bottom: 4px;
      font-size: 12px;
      font-weight: bold;
      color: #474546;
    }

    &-buttons {
      gap: 8px;
      justify-content: flex-end;

      @include respond(desktop) {
        gap: 0;
      }
    }

    .button-container {
      width: 40px;
      height: 40px;
      border-radius: 4px;

      @include respond(desktop) {
        width: 18px;
        height: 18px;
      }
    }

    .v-icon.v-icon--disabled {
      color: rgba(255, 255, 255, 0.2) !important;
    }
  }

  .request-container-no-btn {
    display: grid;
    grid-template-columns: 20px repeat(3, auto);
    align-items: center;

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: red;

      &.online {
        background-color: #93cc41;
      }

      &.unknown {
        background-color: #fff;
      }
    }

    .v-image {
      box-shadow: 0 0 6px gold;
    }

    p {
      line-height: 16px;
    }

    span {
      position: relative;
      bottom: 4px;
      font-size: 12px;
      font-weight: bold;
      color: #474546;
    }

    .button-container {
      width: 18px;
      height: 18px;
      border-radius: 4px;
    }
  }
</style>
